import classNames from "classnames"
import AppIcon from "components/AppIcon"
import CTABtn from "components/CTABtn"
import { Row } from "components/Layout"
import Video from "components/Video"
import useReportScrolledIntoView from "hooks/useReportScrolledIntoView"
import { useRef } from "react"
import css from "./PlayableFeedItem.module.scss"

const PlayableFeedItem = ({ game, onClick }) => {
  const elRef = useRef()

  useReportScrolledIntoView(elRef, "instant play", "instant play game shown", {
    playable_id: game.id,
  })

  return (
    <div
      id={`playable-${game.id}`}
      onClick={onClick}
      className={css.playableFeedItem}
      rel="noreferrer"
      sf="mc"
    >
      <Row
        ref={elRef}
        className={classNames(css.gradientWash, css.bottom)}
        sf="b"
        padding="0 1.5rem"
        style={{ width: "100%" }}
      >
        <Row align="msb" style={{ width: "100%", marginBottom: 40 }} gap="sm">
          <AppIcon src={game.icon} size={36} />

          <h4 col={1}>{game.title}</h4>

          <CTABtn style={{ padding: "0 0.5rem 0 0.75rem" }}>
            <Row align="mc">
              Play
              <img
                alt=""
                src="/img/play_icon.png"
                height={20}
                style={{ marginTop: -3 }}
              />
            </Row>
          </CTABtn>
        </Row>
      </Row>
      <Video src={game.video} poster={game.screenshot} autoPlayThrushold={0.1} />
    </div>
  )
}

export default PlayableFeedItem
